import { render, staticRenderFns } from "./PaymentRequestPopover.vue?vue&type=template&id=58ad95c6"
import script from "./PaymentRequestPopover.vue?vue&type=script&lang=js"
export * from "./PaymentRequestPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports